import { useI18n } from "@/i18n/I18nProvider";
import { cn } from "@/lib/utils";

export default function LanguageToggle({ className = "", variant = "default" }) {
  const { lang, setLang, t } = useI18n();
  const isLight = variant === "light";

  return (
    <div
      data-testid="language-toggle"
      role="group"
      aria-label={t("lang.label")}
      className={cn(
        "inline-flex items-center rounded-full border p-0.5 text-[11.5px] font-medium tracking-wide select-none",
        isLight
          ? "border-white/15 bg-white/[0.05]"
          : "border-brand-line bg-white/70 backdrop-blur",
        className,
      )}
    >
      <button
        type="button"
        data-testid="lang-en"
        aria-pressed={lang === "en"}
        onClick={() => setLang("en")}
        className={cn(
          "px-2.5 py-1 rounded-full transition-colors",
          lang === "en"
            ? isLight
              ? "bg-white/90 text-brand-charcoal"
              : "bg-brand-charcoal text-brand-off"
            : isLight
              ? "text-white/65 hover:text-white"
              : "text-brand-muted hover:text-brand-charcoal",
        )}
      >
        {t("lang.short_en")}
      </button>
      <button
        type="button"
        data-testid="lang-lv"
        aria-pressed={lang === "lv"}
        onClick={() => setLang("lv")}
        className={cn(
          "px-2.5 py-1 rounded-full transition-colors",
          lang === "lv"
            ? isLight
              ? "bg-white/90 text-brand-charcoal"
              : "bg-brand-charcoal text-brand-off"
            : isLight
              ? "text-white/65 hover:text-white"
              : "text-brand-muted hover:text-brand-charcoal",
        )}
      >
        {t("lang.short_lv")}
      </button>
    </div>
  );
}
